<template>
    <div class="ml-20">
        <a-list class="mb-10" item-layout="horizontal">
            <a-list-item>
                <a-list-item-meta>
                    <div slot="title">
                        <span class="mt-30 font-web mb-10" style="font-size: 18px;color: #610C9F !important;">
                            FAQ
                        </span>
                    </div>
                    <div slot="description">
                        <span class="font-web" style="font-size: 14px;">คำถามที่พบบ่อย</span>
                    </div>
                    <a-avatar :style="{ backgroundColor: '#610C9F' }" slot="avatar" shape="square" :size="55"
                        icon="question-circle" />
                </a-list-item-meta>
            </a-list-item>
        </a-list>

        <span v-if="dataFaq.length !== 0">
            <a-collapse accordion v-for="(list, index) in dataFaq" :key="'faq' + index">
                <a-collapse-panel :key="list.id">
                    <p class="mb-0 mt-0" slot="header" style="font-size: 18px;font-weight: 300;color: black !important;">{{ list.question }}</p>
                    <a-alert type="info" banner style="border-radius: 5px;">
                        <span slot="message" style="font-size: 16px !important;color: black;" v-html="list.answer"></span>
                    </a-alert>
                </a-collapse-panel>
            </a-collapse>
        </span>
        <div v-else class="text-center">
            <a-empty><span slot="description">No FAQ data!</span></a-empty>
        </div>

        <!--  -->

    </div>
</template>

<script>
import MobileFrame from '../MobileFrame.vue';

export default {
    props: {
        dataFaq: {
            type: Array,
            default: () => []
        }
    },
    components: {
        MobileFrame,
    },
    data() {
        return {
            text: `A dog is a type of domesticated animal.Known for its loyalty and faithfulness,it can be found as a welcome guest in many households across the world.`,
        };
    },
    methods: {
        toIcService() {
            this.$router
                .push({
                    path: "/service/form",
                })
                .catch((err) => { });
        }
    }
}
</script>